exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-header[data-v-4be1f66c] {\n    position: relative;\n    z-index: 2;\n}\n.product-details-loader[data-v-4be1f66c] {\n    color: white;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 30px;\n    background-color: #000000;\n    z-index: 1;\n    text-align: center;\n    top: 0;\n}\n.product-thumb[data-v-4be1f66c] {\n    width: 20%;\n}\n.product-name[data-v-4be1f66c] {\n    width: 80%;\n    padding-left: 15px;\n}\n", ""]);

// exports
